import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PlenaryDoc } from '../models/plenary-docs.model';
import { GLOBAL } from './global.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class PlenaryDocsService {
  private url: string;
  private contType = {
    h: 'Content-Type',
    b: 'application/json',
  }
  private auth = {
    h: 'Authorization',
    b: '',
  }

  constructor(private _http: HttpClient, userService: UserService) {
    this.url    = GLOBAL.API.url;
    this.auth.b = userService.getToken();
  }

  getDocumentsForAdmin: () => Observable<any> = () => {
    let headers = new HttpHeaders().set(this.contType.h, this.contType.b).set(this.auth.h, this.auth.b);
    return this._http.get(`${this.url}admin/documents`, { headers });
  }

  addDocument: (document: PlenaryDoc) => Observable<any> = document => {
    let params = JSON.stringify(document);
    let headers = new HttpHeaders().set(this.contType.h, this.contType.b).set(this.auth.h, this.auth.b);
    return this._http.post(`${this.url}admin/documents`, params, { headers });
  }

  deleteDocument: (docId: string) => Observable<any> = newsId => {
    let headers = new HttpHeaders().set(this.contType.h, this.contType.b).set(this.auth.h, this.auth.b);
    return this._http.delete(`${this.url}admin/documents/${newsId}`, { headers });
  }

  updateDocument: (document: PlenaryDoc) => Observable<any> = document => {
    let params = JSON.stringify(document);
    let headers = new HttpHeaders().set(this.contType.h, this.contType.b).set(this.auth.h, this.auth.b);
    return this._http.put(`${this.url}admin/documents/${document.id}`, params, { headers });
  }
}
